module.exports = __webpack_public_path__ + "media/images/warning-4cb9fc828a89d8bc3e696eb81a3bdb3e.png";